export const ServiceTypeFilter = {
    methods: {
        processServiceTypeFilter(service, type) {
            switch(type) {
                case 'slots':
                    if (service.maintenance_slot == true) {
                        return true;
                    } else {
                        return false;
                    }
                    break;

                case 'clients':
                    if (service.maintenance_slot == false) {
                        return true;
                    } else {
                        return false;
                    }
                    break;

                case 'all':
                    return true;
                    break;
            }
        }
    }
}
